import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';

const License = () => {

    // List of license PDFs from the License folder
    const licenses = [
        {
            id: 1,
            name: "ISO 9001:2015 Quality Management System",
            filename: "2882-TEXCELLENCE SPECIALITIES PRIVATE LIMITED.pdf",
            description: "Quality Management System Certification",
            category: "Quality Management",
            validUntil: "2027-12-31",
            issuer: "Bureau Veritas"
        },
        {
            id: 2,
            name: "ISO 14001:2015 Environmental Management System",
            filename: "2883-TEXCELLENCE SPECIALITIES PRIVATE LIMITED-14001.pdf",
            description: "Environmental Management System Certification",
            category: "Environmental",
            validUntil: "2027-12-31",
            issuer: "Bureau Veritas"
        },
        {
            id: 3,
            name: "ISO 45001:2018 Occupational Health & Safety Management",
            filename: "2884-TEXCELLENCE SPECIALITIES PRIVATE LIMITED-45001.pdf",
            description: "Occupational Health & Safety Management System Certification",
            category: "Health & Safety",
            validUntil: "2027-12-31",
            issuer: "Bureau Veritas"
        },
        {
            id: 4,
            name: "Good Manufacturing Practice (GMP)",
            filename: "3921-TEXCELLENCE SPECIALITIES PRIVATE LIMITED- GMP.pdf",
            description: "Good Manufacturing Practice Certification",
            category: "Manufacturing",
            validUntil: "2027-12-31",
            issuer: "Bureau Veritas"
        }
    ];

    const handleViewPDF = (filename) => {
        window.open(`/licenses/${filename}`, '_blank');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <NavBar />
            
            {/* Header Section */}
            <div className="pt-32 pb-16 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-[#5b2a2a] mb-4 tracking-tight leading-tight">
                        Our Certifications &amp; Licenses
                    </h1>
                    <p className="text-lg text-[#4b5563] max-w-3xl mx-auto leading-relaxed">
                        Texcellence Specialities Private Limited is proud to hold various international certifications
                        that demonstrate our commitment to quality, environmental responsibility, and workplace safety.
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
                {/* Stats Section - Compact */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
                    <div className="bg-white rounded-lg shadow p-4 text-center">
                        <div className="text-2xl font-bold text-[#5b2a2a] mb-1">4</div>
                        <div className="text-sm text-gray-600">Active Certifications</div>
                    </div>
                    <div className="bg-white rounded-lg shadow p-4 text-center">
                        <div className="text-2xl font-bold text-[#5b2a2a] mb-1">100%</div>
                        <div className="text-sm text-gray-600">Compliance Rate</div>
                    </div>
                    <div className="bg-white rounded-lg shadow p-4 text-center">
                        <div className="text-2xl font-bold text-[#5b2a2a] mb-1">2027</div>
                        <div className="text-sm text-gray-600">Valid Until</div>
                    </div>
                    <div className="bg-white rounded-lg shadow p-4 text-center">
                        <div className="text-2xl font-bold text-[#5b2a2a] mb-1">ISO</div>
                        <div className="text-sm text-gray-600">Standards</div>
                    </div>
                </div>

                {/* Licenses Grid - 4 columns */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {licenses.map((license) => (
                        <div key={license.id} className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden">
                            {/* Certificate Image - Clickable */}
                            <div 
                                className="w-full h-48 bg-gray-100 cursor-pointer hover:opacity-90 transition-opacity duration-300 relative group"
                                onClick={() => handleViewPDF(license.filename)}
                            >
                                <img 
                                    src={`/licenses/${license.filename.replace('.pdf', '.jpg')}`}
                                    alt={`${license.name} certificate`}
                                    className="w-full h-full object-cover"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                    }}
                                />
                                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200" style={{display: 'none'}}>
                                    <div className="text-center">
                                        <div className="w-16 h-16 bg-[#5b2a2a] rounded-full flex items-center justify-center mx-auto mb-3">
                                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <p className="text-sm text-gray-600 font-medium">Certificate Preview</p>
                                    </div>
                                </div>
                                
                                {/* Hover overlay */}
                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        <div className="bg-white bg-opacity-90 rounded-full p-3">
                                            <svg className="w-6 h-6 text-[#5b2a2a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Certificate Information */}
                            <div className="p-4">
                                <h3 className="text-lg font-bold text-[#5b2a2a] mb-3 leading-tight">
                                    {license.name}
                                </h3>

                                <div className="space-y-2 mb-4">
                                    <div className="flex justify-between items-center text-sm">
                                        <span className="text-[#6b7280]">Certificate No:</span>
                                        <span className="font-semibold text-[#5b2a2a]">{license.filename.split('-')[0]}</span>
                                    </div>
                                    <div className="flex justify-between items-center text-sm">
                                        <span className="text-[#6b7280]">Valid Until:</span>
                                        <span className="font-semibold text-[#374151]">{license.validUntil}</span>
                                    </div>
                                    <div className="flex justify-between items-center text-sm">
                                        <span className="text-[#6b7280]">Category:</span>
                                        <span className="font-semibold text-[#5b2a2a]">{license.category}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                {/* Information Section - Compact */}
                <div className="mt-12 bg-white rounded-lg shadow p-6">
                    <h2 className="text-2xl font-bold text-[#5b2a2a] mb-6 text-center tracking-tight">
                        About Our Certifications
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className="text-center">
                            <div className="bg-[#5b2a2a] text-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h3 className="text-sm font-semibold text-[#5b2a2a] mb-1">
                                Quality Assurance
                            </h3>
                            <p className="text-xs text-gray-600">
                                ISO 9001:2015 ensures highest quality management standards.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="bg-[#5b2a2a] text-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h3 className="text-sm font-semibold text-[#5b2a2a] mb-1">
                                Environmental
                            </h3>
                            <p className="text-xs text-gray-600">
                                ISO 14001:2015 demonstrates environmental commitment.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="bg-[#5b2a2a] text-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                </svg>
                            </div>
                            <h3 className="text-sm font-semibold text-[#5b2a2a] mb-1">
                                Workplace Safety
                            </h3>
                            <p className="text-xs text-gray-600">
                                ISO 45001:2018 ensures employee health and safety.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="bg-[#5b2a2a] text-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                                </svg>
                            </div>
                            <h3 className="text-sm font-semibold text-[#5b2a2a] mb-1">
                                Manufacturing
                            </h3>
                            <p className="text-xs text-gray-600">
                                GMP certification guarantees manufacturing excellence.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            
            {/* Footer */}
            <Footer />
        </div>
    );
};

export default License;